import React from 'react';

import PropTypes from 'prop-types';

const VideoVolumeIcon = ({ width = 34, height = 32, color = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 32"
      fill="none"
    >
      <g filter="url(#filter0_d_19689_22153)">
        <path
          d="M19.0791 5.07579C18.9529 5.01433 18.8121 4.98948 18.6726 5.00406C18.533 5.01865 18.4004 5.07208 18.2897 5.15829L11.7422 10.2498H7.5C7.10218 10.2498 6.72064 10.4079 6.43934 10.6892C6.15804 10.9705 6 11.352 6 11.7498V17.7498C6 18.1477 6.15804 18.5292 6.43934 18.8105C6.72064 19.0918 7.10218 19.2498 7.5 19.2498H11.7422L18.2897 24.3414C18.4005 24.4275 18.5332 24.4809 18.6728 24.4953C18.8124 24.5097 18.9533 24.4847 19.0793 24.4231C19.2054 24.3615 19.3117 24.2657 19.3861 24.1467C19.4604 24.0277 19.4999 23.8902 19.5 23.7498V5.74985C19.5 5.60934 19.4606 5.47166 19.3861 5.35248C19.3117 5.23331 19.2053 5.13743 19.0791 5.07579ZM11.25 17.7498H7.5V11.7498H11.25V17.7498ZM23.0625 12.2711C23.6657 12.9559 23.9986 13.8372 23.9986 14.7498C23.9986 15.6625 23.6657 16.5438 23.0625 17.2286C22.93 17.3742 22.7456 17.4619 22.549 17.4727C22.3524 17.4835 22.1595 17.4166 22.0118 17.2864C21.8642 17.1562 21.7736 16.9731 21.7597 16.7768C21.7458 16.5804 21.8097 16.3864 21.9375 16.2367C22.2992 15.8259 22.4988 15.2973 22.4988 14.7498C22.4988 14.2024 22.2992 13.6738 21.9375 13.263C21.8097 13.1133 21.7458 12.9193 21.7597 12.7229C21.7736 12.5266 21.8642 12.3435 22.0118 12.2133C22.1595 12.0831 22.3524 12.0162 22.549 12.027C22.7456 12.0378 22.93 12.1255 23.0625 12.2711ZM27.75 14.7498C27.7511 16.595 27.0711 18.3757 25.8403 19.7505C25.7067 19.895 25.5216 19.9813 25.325 19.9906C25.1284 19.9999 24.936 19.9315 24.7893 19.8003C24.6426 19.669 24.5535 19.4853 24.541 19.2888C24.5286 19.0924 24.5939 18.8989 24.7228 18.7502C25.7066 17.6501 26.2505 16.2261 26.2505 14.7503C26.2505 13.2745 25.7066 11.8505 24.7228 10.7505C24.6553 10.6774 24.603 10.5916 24.5689 10.4981C24.5349 10.4047 24.5197 10.3053 24.5245 10.206C24.5292 10.1066 24.5536 10.0091 24.5963 9.91926C24.6391 9.82942 24.6993 9.74897 24.7734 9.68261C24.8475 9.61625 24.9341 9.56531 25.0281 9.53274C25.1222 9.50018 25.2217 9.48665 25.321 9.49293C25.4203 9.49922 25.5173 9.5252 25.6065 9.56936C25.6957 9.61352 25.7751 9.67498 25.8403 9.75016C27.0714 11.1244 27.7515 12.9049 27.75 14.7498Z"
          fill={color}
          fillOpacity="0.9"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_19689_22153"
          x="-5.5"
          y="-7.25"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19689_22153"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19689_22153"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

VideoVolumeIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default VideoVolumeIcon;
